import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from './reducers/app-store';
import * as AppActions from './reducers/app-action';
import { CategoryService } from './services/category.service';
import { Subscription } from 'rxjs';
import { Category } from './models/category';
import { data } from 'jquery';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'e-commerce';

  subscriptions: Subscription[];

  constructor(
    private categoryService: CategoryService,
    private store: Store<{ appState: AppState }>) {

  }

  ngOnInit() {
    this.subscriptions = [
      this.categoryService.getAll().subscribe(items => {
        const subCategories: string[] = [];
        const categories: Category[] = items.map(a => {
          const data = a.payload.doc.data() as Category;
          data.id = a.payload.doc.id;
          data.subCategories.forEach(item => {
            if (!subCategories.find(sc => sc.toLowerCase() === item.toLowerCase())) {
              subCategories.push(item);
            }
          });
          return data;
        });
        this.store.dispatch(AppActions.loadCategories({ categories }));
        this.store.dispatch(AppActions.loadSubCategories({ subCategories }));
      }),
    ];
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
